import { FormField } from "components/SmartSurveyor/ReviewPage/FormField";
import { useFieldContext } from "./formContext";
import type { NumberFieldProps } from "./types";

export const NumberField = ({
  label,
  isEditable,
  step,
  min,
  max,
  inputMode,
}: NumberFieldProps) => {
  const field = useFieldContext<number>();

  if (!isEditable) {
    return (
      <FormField
        label={label}
        type="number"
        value={field.state.value}
        step={step}
        min={min}
        max={max}
        inputMode={inputMode}
      />
    );
  }

  return (
    <FormField
      label={label}
      type="number"
      value={field.state.value}
      onChange={field.handleChange}
      onBlur={field.handleBlur}
      step={step}
      min={min}
      max={max}
      inputMode={inputMode}
      error={field.state.meta.errors?.[0]?.message}
    />
  );
};
